module.exports = __webpack_public_path__ + "img/icon-sb-white-glove-desktop.2cec533.svg";